import { observer } from "mobx-react-lite";
import AccountView from "../views/accountView";

const AccountPresenter = observer(
  function AccountRender(props) {

    const handleUsernameChange = (newUsername) => {
      props.model.setUsername(newUsername);
    };

    return (
      <AccountView
        username={props.model.username}
        emailAddress={props.model.emailAddress}
        setUsername={handleUsernameChange} 
      />
    );
  }
);

export { AccountPresenter };
